import { useEffect, useState } from "react";
import { getFeaturedCategories } from "../services/api";
import { Link } from "react-router-dom"; // assuming you're using react-router
import { useCategoryStore } from "../store/categoryStore";

export const FeaturedCategories = () => {
  const categories = useCategoryStore((s) => s.categories);

  if (!categories.length) {
    return (
      <div className="text-center py-8">Loading featured categories...</div>
    );
  }

  return (
    <section className="px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-6 md:py-10 lg:py-10 sm:py-10 xs:py-8 xxs:py-6  mx-auto">
      <h3 className="text-4xl font-serif text-light_primary mb-6">
        Featured Categories
      </h3>
      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {categories &&
          categories.map((cat) => (
            <Link
              key={cat._id}
              to={`/products/${cat.slug}`} // redirect to products page
              className="bg-light_cream rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
            >
              <img
                src={cat.image || "https://placebear.com/g/200/200"} // fallback image
                alt={cat.name}
                className="w-full h-48 object-cover"
              />
              <div className="text-2xl font-serif p-4 text-center font-medium text-secondary">
                {cat.name}
              </div>
            </Link>
          ))}
      </div>
    </section>
  );
};
